// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"fe78998e","453":"8bcfb11a"}[chunkId] + ".chunk.js";
};